import { FC } from 'react';
import { MemberInfoContainer } from '../components/member-info.container';

interface MemberInfoPageProps {}
export const MemberInfoPage: FC<MemberInfoPageProps> = (props) => {
  return <MemberInfoContainer />;
};
